const removeLastWordAfterScript = (text: string): string => {
  const lastIndex = text.lastIndexOf('-');
  return text.substr(0, lastIndex);
};

export default removeLastWordAfterScript;
